/* import __COLOCATED_TEMPLATE__ from './modal.hbs'; */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import { closeModal } from 'sh-www/utils/modal-controls';
import clsx from 'clsx';

const CLASS_NAME = 'GLM-modal';
const CLASS_NAME_NO_PADDING_AT_FULL_WIDTH = `${CLASS_NAME}--no-padding-at-full-width`;
const CONTENT_CLASS_NAME = `${CLASS_NAME}__content`;
const OVERLAY_CLASS_NAME = `${CLASS_NAME}__overlay`;
const WRAPPER_CLASS_NAME = `${CLASS_NAME}__wrapper`;

/**
 * Possible widths
 *
 * @type {Object}
 */
export const GLM_MODAL_WIDTH_TYPE = {
  WIDTH_400_PX: '400_px',
  WIDTH_600_PX: '600_px',
  WIDTH_800_PX: '800_px',
  WIDTH_MAX: 'max',
};

class GlmModalComponent extends Component {
  get classNames() {
    return clsx(
      this.args.class,
      CLASS_NAME,
      this.args.noPaddingAtFullWidth && CLASS_NAME_NO_PADDING_AT_FULL_WIDTH,
      this.is400WidthType && `${CLASS_NAME}--width-type-400-px`,
      this.is600WidthType && `${CLASS_NAME}--width-type-600-px`,
      this.is800WidthType && `${CLASS_NAME}--width-type-800-px`,
      this.isMaxWidthType && `${CLASS_NAME}--width-type-max`,
    );
  }

  get contentClassNames() {
    return clsx(
      this.args.contentClass,
      CONTENT_CLASS_NAME,
    );
  }

  get overlayClassNames() {
    return clsx(
      this.args.overlayClass,
      OVERLAY_CLASS_NAME,
    );
  }

  get wrapperClassNames() {
    return clsx(
      this.args.wrapperClass,
      WRAPPER_CLASS_NAME,
    );
  }

  get className() {
    return CLASS_NAME;
  }

  get dismissible() {
    return this.args.isDismissible ?? true;
  }

  get widthType() {
    return this.args.widthType ?? GLM_MODAL_WIDTH_TYPE.WIDTH_400_PX;
  }

  get is400WidthType() {
    return this.widthType === GLM_MODAL_WIDTH_TYPE.WIDTH_400_PX;
  }

  get is600WidthType() {
    return this.widthType === GLM_MODAL_WIDTH_TYPE.WIDTH_600_PX;
  }

  get is800WidthType() {
    return this.widthType === GLM_MODAL_WIDTH_TYPE.WIDTH_800_PX;
  }

  get isMaxWidthType() {
    return this.widthType === GLM_MODAL_WIDTH_TYPE.WIDTH_MAX;
  }

  @action
  onClickOverlay() {
    if (!this.dismissible) {
      return;
    }

    closeModal(this);
  }

  @action
  handleKeyUp(e) {
    if (e.defaultPrevented) {
      return;
    }

    // enable standard accessibility
    if (e.key === 'Escape' && this.dismissible) {
      e.preventDefault();

      closeModal(this);
    }
  }
}

export default GlmModalComponent;
